import { MapPin, ArrowUpRight, Sparkles } from "lucide-react";
import { LOCATIONS } from "@/data/siteData";
import { HOME } from "@/constants/testIds";

export default function Locations() {
  return (
    <section id="dove-ricevo" className="relative py-24 md:py-32 bg-[#EEF5F9]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="overline">Dove ricevo</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
            Quattro studi in Sardegna.
          </h2>
          <p className="mt-6 text-gray-600 leading-relaxed">
            Ricevo in libera professione, su appuntamento, a Portoscuso,
            Carloforte, Sestu e Cagliari.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {LOCATIONS.map((loc) => (
            <div
              key={loc.city}
              data-testid={HOME.locationCard(loc.city)}
              className={`relative rounded-2xl border overflow-hidden group transition-all duration-500 hover:shadow-[0_12px_40px_rgba(11,74,90,0.08)] ${
                loc.badge
                  ? "border-[#C6A86B]/50 shadow-[0_8px_28px_rgba(198,168,107,0.14)]"
                  : "border-gray-100 hover:border-[#C6A86B]/30"
              }`}
            >
              {loc.badge && (
                <span className="absolute top-4 right-4 z-10 inline-flex items-center gap-1.5 bg-[#C6A86B] text-white text-[10px] font-medium tracking-[0.16em] uppercase px-3 py-1.5 rounded-full shadow-md">
                  <Sparkles size={11} strokeWidth={2} />
                  {loc.badge}
                </span>
              )}
              <div className="map-bg h-40 relative">
                <MapPin
                  className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[#0B4A5A] group-hover:scale-110 transition-transform duration-500"
                  size={32}
                  strokeWidth={1.3}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white" />
              </div>
              <div className="bg-white p-7">
                <p className="text-[11px] uppercase tracking-[0.2em] text-[#C6A86B]">
                  {loc.note}
                </p>
                <h3 className="font-serif text-2xl mt-2 text-[#0B4A5A]">
                  {loc.city}
                </h3>
                <p className="mt-2 text-sm text-gray-600">{loc.address}</p>
                {loc.openDate && (
                  <p className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-[#C6A86B] bg-[#C6A86B]/10 rounded-full px-3 py-1">
                    ✦ {loc.openDate}
                  </p>
                )}
                <a
                  data-testid={HOME.locationMaps(loc.city)}
                  href={loc.maps}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 mt-5 text-sm text-[#0B4A5A] font-medium link-underline"
                >
                  Apri in Maps
                  <ArrowUpRight size={14} strokeWidth={1.5} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
